import { initialState, THelperMethods, THelperStore } from "./helper.state";
import { helperReducer } from "./helper.reducer";

// ✅ Reusable store methods
export const createHelperActions = (
    set: any,
    // get: () => THelperStore
): Pick<THelperStore, THelperMethods> => ({
    dispatch: (action) => set((state: THelperStore) => helperReducer(state, action)),

    reset: () => {
        set(initialState);
    },
});
